module.exports = __webpack_public_path__ + "static/img/m_name.3fe7ae8.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/sy/m_name.png
// module id = k+ZC
// module chunks = 7